export default __webpack_public_path__ + "static/media/nova.7482095d.webp";